import { getClient } from '@api/client';
import { FollowUpInteractionInput } from '@api/generated/graphql';
import extractErrorMessage from '@lib/utils/extractErrorMessage';
import { ADD_FOLLOW_UP_INTERACTION_MUTATION } from './mutations';

const addFollowUpInteraction = async (
  followUpId: string,
  input: FollowUpInteractionInput,
) => {
  try {
    const { data } = await getClient().mutate({
      mutation: ADD_FOLLOW_UP_INTERACTION_MUTATION,
      variables: { followUpId, input },
    });

    if (!data?.addFollowUpInteraction) {
      throw new Error('No data');
    }

    return data?.addFollowUpInteraction;
  } catch (err) {
    throw new Error(extractErrorMessage(err));
  }
};

export default addFollowUpInteraction;
